import styled from "styled-components";
import {colors, devices, fonts} from "../../utils/styled/_variables.styled";
import {InfiosLink} from '../Link/Link.style';
import "../../base/styled/_typograhpy.style";
import { InfiosBreadcrumb } from "../Breadcrumb/Breadcrumb.style";

const InfiosStage = styled.section`
    -webkit-overflow-scrolling: touch;

		* {
			font-family: ${fonts.AeonikPro};
		}

    .stage__bg {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .stage {
        width: 100%;
        position: relative;
        overflow: hidden;

        &.stage__padding {
            padding-left: 96px;
            padding-right: 96px;

            @media ${devices.desktop} {
                padding-left: 96px;
                padding-right: 96px;
            }

            @media ${devices.tablets} {
                padding-left: 48px;
                padding-right: 48px;
            }

            @media ${devices.mobile} {
                padding-left: 24px;
                padding-right: 24px;
            }
        }

        .stage__grid {
            max-width: 1512px;
            margin: 0 auto;
        }

        &__banner {
            display: flex;
            position: relative;
            justify-content: justify;
            align-items: flex-start;
            background-position: center;
            transition: height 0.3s ease-in-out;
            height: 500px;


          .heading-1 {
						font-size: 80px;
						font-weight: 400;
						line-height: 92.2%;
						letter-spacing: -2.4px;

						@media ${devices.mobile} {
							font-size: 50px;
						}
          }

          .leadText{
            ${props => props.leadTextColor ? `color: ${props.leadTextColor}` : ""}

            p{
							font-size:19px;
						}
          }

            &:not(.stage__banner-small) {
                height: 1044px;

                @media ${devices.tabletLarge} {
                    height: 1228px;
                }

                @media ${devices.mobile} {
                    height: ${props => props.teaserTitle ? 1070 : 924}px;
                }
            }


            &.stage-l1 {
                height: 100%;
                padding-left: 32px;
                min-height: 900px;
								display: flex;
								flex-direction: column;
								justify-content: flex-end;
								padding-bottom: 58px;

                @media ${devices.desktop} {
                    flex-direction: row;
                    align-items: flex-end;
                    justify-content: space-between;
                    padding-bottom: 70px;
										padding-top: 130px;
                }

                @media ${devices.tabletLarge} {
                    padding-left: 28px;
                    min-height: 860px;
										gap: 50px;
                }

                @media ${devices.mobile} {
                    padding-left: 24px;
                    min-height: ${props => props.teaserTitle ? 860 : 860}px;
										gap: 50px;
                }

                .stage__banner-container {
                    display: flex;
                    flex-direction: column;
										position: relative;

										@media ${devices.desktop} {
											width: 50%;
										}

                    .arrow-animated {
                        margin-top: 50px;

                        @media ${devices.tablets} {
                            display: none;
                        }

                        @media ${devices.mobile} {
                            display: none;
                        }

                        svg {
                            transition: transform 0.3s ease-out, opacity 0.3s ease-out;
                            cursor: pointer;

                            @media ${devices.mobile} {
                                display: none;
                            }

                            &:hover {
                                transform: translateY(4px);
                                opacity: 0.64;
                            }
                        }
                    }
                }
            }

            &-small {
                min-height: 756px;
                max-height: 950px;
                padding-bottom: 132px;
                padding-top: 228px;

                @media ${devices.tablets} {
                    min-height: 972px;
                    max-width: 100%;
                    padding-bottom: 112px;
                    padding-top: 192px;
                }

                @media ${devices.mobile} {
                    padding-bottom: 104px;
                    padding-top: 178px;
                    min-height: 700px;
                    max-height: 745px;
                }

                .stage__banner-video {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    min-width: 100%;
                    min-height: 100%;
                    z-index: -1;
                    width: 100%;
                    height: 300px;
                }

                .stage__banner-container {
                    margin: auto 0 0 0;

                    @media ${devices.tabletLarge} {
                        margin: auto 0 0 0;
                    }

                    @media ${devices.mobile} {
                        margin: auto 0 0 0;
                    }

                    .stage__banner-texts {
                        max-width: 644px;
                        width: 100%;

                        @media ${devices.mobileAndTablet} {
                            max-width: 100%;

                            h1, p {
                                max-width: 100%;
                                width: 100%;
                            }
                        }
                    }
                }
            }
            &-video {
                position: absolute;
                width: 100%;
                height: 100%;
                object-fit: cover;
                inset: 0;
                z-index: -1;
            }
            &-container  {
                max-width: 1080px;
                margin: 0;

                @media ${devices.tabletLarge} {
                    margin: 160px 0 0 0;
                }
                @media ${devices.mobile} {
                    margin: 128px 0 0 0;
                }
                p {
                    margin-top: 32px;
                    font-size: 30px;
										font-weight: 400;
										line-height: 130.2%!important;
										letter-spacing: -0.6px;
                    @media ${devices.tabletLarge} {
                        font-size: 24px;
                    }
                    @media ${devices.mobile} {
											font-size: 23.313px;
											font-weight: 400;
											line-height: 115.2%!important;
											letter-spacing: -0.466px;
                    }
                }
            }
            &-texts{
                position: relative;

                h1, p {
                    color: ${colors.white};
                    width: 100%;

                    @media ${devices.tabletLarge} {
                        //max-width: 405px;
                    }

                    @media ${devices.mobile} {
                        max-width: 100%;
                        width: 100%;
                    }
                }

                p {
                    line-height: 36px;

                    @media ${devices.tablets} {
                        line-height: 30px;
                    }

                    @media ${devices.mobile} {
                        max-width: 100%;
                        width: 100%;
                        line-height: 27px;
                        margin-top: 24px;
                    }
                }

            }
            &-box{
                display: flex;
                flex-direction: column;
                background-color: ${colors.white};
                padding: 32px;
                background-color: #FFFFFF;
                height: 230px;
                width: 420px;
								margin-bottom: 100px;

                @media ${devices.tablets} {
                    padding: 28px;
                    height: 204px;
                    width: 412px;
										margin-bottom: unset;
                }

                @media ${devices.mobile} {
                    height: 210px;
                    width: calc(100% - 24px);
                    padding: 24px;
                    margin: 0;

                    a {
                        white-space: normal;
                    }
                }

                &-p {
                    margin-top: 12px;
                    font-weight: 300;

                    @media ${devices.mobile} {
                        margin-top: 8px;
                    }
                }
                &-link {
                    align-items: flex-end;
                    display: flex;
                    justify-content: flex-end;
                    height: 100%;
                }

                &:hover {
                    background: ${colors.gray1};
                    transition: .3s ease-in-out;

                    ${InfiosLink}{

                        &:active{
                            color: ${colors.white};
                            svg {
                                path {
                                    fill: ${colors.white};
                                }
                        }
                        }

                    }
                }
            }

            .stage__right-text {
                position: absolute;
                right: 0;
                bottom: 550px;
                display: none;
                gap: 8px;

                @media ${devices.desktop} {
                    display: flex;
                    align-items: center;
                }

                svg {
                    cursor: pointer;
                }

                span {
                    font-size: 30px;
                    color: ${colors.white};
										font-weight: 400;
                }
            }
        }
        &__content {
            display: flex;
            flex-direction: column;
            align-items: center;

            &-container {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 132px 96px 50px;
                align-items: flex-start;
                width: 100%;
                @media ${devices.tabletLarge} {
                width: calc(100% - 96px);
                margin: 140px 48px 0;
                }
                @media ${devices.mobile} {
                width: calc(100% - 48px);
                margin: 120px 24px 0;
                }

                .stage__content-texts {
                    width: 100%;
                }
            }

            &-texts {
                display: flex;
                flex-direction: column;
                gap: 32px;
                margin: 0 auto;
                max-width: 870px;
                align-items: flex-start;

                @media ${devices.tablets} {
                    padding: 0px 0px 50px;
                    max-width: 100%;
                    gap: 28px;

                }

                @media ${devices.mobile} {
                    padding: 20px 0;
                    max-width: 100%;
                    gap: 24px;
                }

                .leadText {
                    font-style: normal;
                    font-weight: 300;
                    font-size: 24px;
                    line-height: 150%;

                    @media ${devices.tabletLarge} {
                        font-size: 20px;
                    }

                    @media ${devices.mobile} {
                        font-size: 18px;
                    }
                }
            }
        }

        .large__type-time {
            display: flex;
            height: 12px;
            position: absolute;
            top: -21px;
            left: 2px;
            @media ${devices.tabletLarge} {
                top: -17px;
            }
            .content__type{
                font-size: 10px;
                width: unset;
                margin-top: unset;
                padding-right: 8px;
                border-right: 1px solid rgba(255, 255, 255, 0.32);
                margin-right: 8px;
                color: ${colors.white}
            }
            svg{
                width: 12px;
                height: 12px;
                padding-bottom: 1px;

            }
            .content__time{
                font-size: 10px;
                margin-top: unset;
                opacity: 0.64;
                width: unset;
                font-weight: 600;
                margin-left: 5px;
                line-height: 12px;

            }

        }

        ${InfiosBreadcrumb} {
            min-height: 20px !important;
            display: flex;
            margin-top: 0;
            z-index: 1;

            .cmp-breadcrumb {
                padding: 0;

                ol {
                    height: 20px;
                }
            }

        }
    }

    .buttons__wrapper {
        display: flex;
        gap: 24px;
        flex-wrap: wrap;
        margin-top: 32px;

				button {
					svg {
						transition: transform 300ms ease;
					}
					&:hover {
						svg {
							transform: translate(4px, 0);
						}
					}
				}

        @media ${devices.tablets} {
            margin-top: 28px;
        }

        @media ${devices.mobile} {
            margin-top: 24px;
        }
    }

`
export { InfiosStage };
